export default "__VITE_ASSET__4551e229__"